import Footer from '../../Components/Footer'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Container, Divider, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { Variants, motion } from "framer-motion"
import DrawerAppBar from '../../Components/DrawerAppBar';
import Menus from '../../Components/Menus';
import TitrePage from '../../Components/TitrePage';
import EllipseGauche from "../../Fichiers/Ellipse 200.svg"
import EllipseDroite from "../../Fichiers/Ellipse 201.svg"
import illution_4 from "../../Fichiers/illution_4.svg";
import { TextFields } from '@mui/icons-material';

interface Props { }

function PretEntreprise(props: Props) {
        const { t } = useTranslation();
        

    const scroll: Variants = {
        offscreen: {
            x: 80,
            opacity: .3
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };


    return (
        <div style={{ backgroundColor: "inherit" }}>
            <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={'PRODUITS_SERVICES.titre30'} lien={'Label.Titre.titre9'} />
            <br /><br /><br /><br /><br /><br /><br /><br />



            <Box display={"flex"} lineHeight={1.6} textAlign={"justify"}>
                <img style={{ width: "5%", marginRight: "2%" }} draggable={false} src={EllipseGauche} alt="" />

                <Container maxWidth='lg'>

                    <Box>

                        <Box textAlign={"justify"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <img width={"100%"} src={illution_4} alt="" /><br />

                            </motion.div>
                            <label style={{ fontSize: 'xx-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("PRET_AUX_ENTREPRISES.texte.partie1").toUpperCase()}</label>
                            <br />

                        </Box>
                    </Box>
                    <br />

                    <br /><br />
                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("PRET_AUX_ENTREPRISES.texte.partie2").toUpperCase()}
                            </label>
                        </motion.div>
                    </Box>
                    <br />
                    <Box display={{ xs: 'block', sm: 'flex' }} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' htmlFor="">
                                    {t("PRET_AUX_ENTREPRISES.texte.partie3")}
                                </label>
                            </motion.div>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={400} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie13")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie14").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>






                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie15")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie16").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>




                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie17")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie18").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>



                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie19")}
                        </label>
                    </motion.div>
                    <br />
                    <label className='textgray' htmlFor="">
                        {t("PRET_AUX_ENTREPRISES.texte.partie20")}
                    </label>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie21").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <label className='textgray' htmlFor="">
                        <i>{t("PRET_AUX_ENTREPRISES.texte.partie22")}</i>
                    </label>




                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("PRET_AUX_ENTREPRISES.texte.partie4").toUpperCase()}
                            </label>

                        </motion.div>
                    </Box>
                    <br />
                    <Box display={{ xs: 'block', sm: 'flex' }} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large" }} htmlFor="">
                                    {t("PRET_AUX_ENTREPRISES.texte.partie5")}
                                </label>

                            </motion.div>
                            <br /><br />

                            <List style={{ borderLeft: "5px #FFA412 solid" }}>
                                {(t("PRET_AUX_ENTREPRISES.texte.partie23").split("|")).map((t) => (
                                    <>
                                        <ListItem>
                                            <ListItemAvatar>
                                                <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={t}
                                            />
                                        </ListItem>
                                        <Divider variant="inset" component="li" />
                                    </>
                                ))}
                            </List>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={400} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large", fontWeight: "bold" }} htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie24")}
                        </label>

                    </motion.div>
                    <br />

                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie25").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large", fontWeight: "bold" }} htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie26")}
                        </label>

                    </motion.div>
                    <br />

                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie27").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large" }} htmlFor="">
                            <i>{t("PRET_AUX_ENTREPRISES.texte.partie28")}</i>
                        </label>

                    </motion.div>


                    <br /><br />
                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("PRET_AUX_ENTREPRISES.texte.partie6").toUpperCase()}
                            </label>
                        </motion.div>
                    </Box>
                    <br />
                    <Box display={{ xs: 'block', sm: 'flex' }} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' htmlFor="">
                                    {t("PRET_AUX_ENTREPRISES.texte.partie7")}
                                </label>
                            </motion.div>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={400} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie29")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie30").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie31")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie32").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            <i>{t("PRET_AUX_ENTREPRISES.texte.partie33")}</i>
                        </label>
                    </motion.div>


















                    <br /><br />
                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("PRET_AUX_ENTREPRISES.texte.partie8").toUpperCase()}
                            </label>
                        </motion.div>
                    </Box>
                    <br />
                    <Box display={{ xs: 'block', sm: 'flex' }} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' htmlFor="">
                                    {t("PRET_AUX_ENTREPRISES.texte.partie9")}
                                </label>
                            </motion.div>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={400} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br />

                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie34")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie35").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie36")}
                        </label>
                    </motion.div>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie37")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie38").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie39")}
                        </label>
                    </motion.div>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie40")}
                        </label>
                    </motion.div>



                    <br /><br />
                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("PRET_AUX_ENTREPRISES.texte.partie10").toUpperCase()}
                            </label>
                        </motion.div>
                    </Box>
                    <br />
                    <Box display={{ xs: 'block', sm: 'flex' }} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' htmlFor="">
                                    {t("PRET_AUX_ENTREPRISES.texte.partie11")}
                                </label><br /><br />

                                <label className='textgray' htmlFor="">
                                    {t("PRET_AUX_ENTREPRISES.texte.partie12")}
                                </label>
                            </motion.div>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={400} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie41")}
                        </label>
                    </motion.div>

                    <br />

                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie42").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>

                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie43")}
                        </label>
                    </motion.div>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie44")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie45").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie46")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRET_AUX_ENTREPRISES.texte.partie47").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label  className='textgray' htmlFor="">
                            {t("PRET_AUX_ENTREPRISES.texte.partie48")}
                        </label>
                    </motion.div>


                    <img width={"50%"} src={illution_4} alt="" />
                    <br /><br />
                </Container>
                <img style={{ width: "5%", marginLeft: "2%" }} draggable={false} src={EllipseDroite} alt="" />
            </Box>

            <Footer />
        </div>
    )
}
export default PretEntreprise